import { Box } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { deleteJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'
import ViewJobAdsDrawer from './ViewJobAdsDrawer'

const JobAdsPopper = ({ id, data, refetch, type }) => {
  //navigate
  const navigate = useNavigate()
  const goToManageEditJobAds = () => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/edit`, {
      state: {
        id,
      },
    })
  }
  // modal
  const cancelModal = useOpenClose(false)
  const deleteSucess = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  // API CALL
  const queryClient = useQueryClient()
  const {
    isLoading: deleteLoading,
    isSuccess: deleteIsSuccess,
    error: deleteError,
    mutate: deleteMutate,
  } = useMutation((id) => deleteJobAds(id), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
      deleteSucess.handleOpen()
      navigate(-1)
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
      errorSnackbar.handleOpen()
    },
  })

  const DeleteJobAdsModal = () => (
    <AdxInfoModal
      modalWidth={600}
      muiIcon="error_icon"
      open={cancelModal.isOpen}
      onClose={cancelModal.handleClose}
      iconColor="error.main"
      title="Delete job advertisement?"
      subtitle="Are you sure you want to delete the job advertisement? Once deleted, you can no longer retrieve applicants data for this job advertisement"
      footerButtons
      firstBtnLabel={'Delete'}
      firstBtnHandle={() => deleteMutate(id)}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={cancelModal.handleClose}
    ></AdxInfoModal>
  )

  // view job ads drawer state
  const [drawerState, setDrawerState] = useState({ right: false })
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }
  if (type === 'active jobs') {
    return (
      <Box display="flex" alignItems="center" columnGap={2}>
        <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
          <Box onClick={handleDrawer('right', true)}>Preview</Box>
          <Box onClick={() => goToManageEditJobAds()}>Edit Details</Box>
        </AdxPopper>

        <ViewJobAdsDrawer
          id={id}
          drawerState={drawerState}
          handleDrawer={handleDrawer}
          data={data}
          refetch={refetch}
        />

        {errorSnackbar.isOpen && (
          <SnackbarRecruitment
            autoHideDuration={4000}
            status="error"
            TransitionComponent="slide"
            message="An error has occured. Please try again"
            open={errorSnackbar.isOpen}
            handleClose={errorSnackbar.handleClose}
          />
        )}
      </Box>
    )
  }
  if (type === 'inactive jobs') {
    return (
      <Box display="flex" alignItems="center" columnGap={2}>
        <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
          <Box onClick={handleDrawer('right', true)}>Preview</Box>
          <Box onClick={() => goToManageEditJobAds()}>Edit details</Box>

          <Box
            sx={{
              color: 'error.main',
            }}
            onClick={cancelModal.handleOpen}
          >
            Delete job
          </Box>
        </AdxPopper>
        {cancelModal.isOpen && <DeleteJobAdsModal />}

        {/*view job ads drawer */}
        <ViewJobAdsDrawer
          id={id}
          drawerState={drawerState}
          handleDrawer={handleDrawer}
          data={data}
          refetch={refetch}
        />

        {deleteSucess.isOpen && (
          <SnackbarRecruitment
            status="success"
            autoHideDuration={4000}
            TransitionComponent="slide"
            message="Job advertisement deleted"
            open={deleteSucess.isOpen}
            handleClose={deleteSucess.handleClose}
          />
        )}

        {errorSnackbar.isOpen && (
          <SnackbarRecruitment
            status="error"
            autoHideDuration={4000}
            TransitionComponent="slide"
            message="An error has occured. Please try again"
            open={errorSnackbar.isOpen}
            handleClose={errorSnackbar.handleClose}
          />
        )}
      </Box>
    )
  }
}
export default JobAdsPopper
